import NativeMaterialScrollTop from './components/native-material-scrolltop'
import NativeSlider from './components/native-slider'
import ObservableViewMetrics from './components/observable-view-metrics'
import PhoneNumberInputSanitizer from './components/phone-number-input-sanitizer'
//import NativeLiveSearch from './components/native-live-search'

export default {
  initializerOpts: {
    mountedModulePrefix: '__'
  },
  modules: {
    nativeMaterialScrollTop: {
      module: NativeMaterialScrollTop,
      listenerOpts: { passive: true }
    },
    nativeSlider: {
      module: NativeSlider
    },
    ObservableViewMetrics: {
      module: ObservableViewMetrics
    },
    PhoneNumberInputSanitizer: {
      module: PhoneNumberInputSanitizer
    },
    // Enable this module if searchPartsEnabled solr version is 'v2'
    //NativeLiveSearch: {
    //  module: NativeLiveSearch
    //}
  }
}
